// @flow

import KMLIcon from 'assets/kml.svg';
import MultipleIcon from 'assets/multiple.svg';
import ErrorIcon from 'assets/error.svg';
import UnknownIcon from 'assets/unknown.svg';
import ProcessingIcon from 'assets/processing.svg';

import { cyan600, red600, grey600 } from 'material-ui/styles/colors';

const DND_STATES = {
  awaitDrop: {
    message: 'Ejts ide bármikor egy .KML/.KMZ fájlt a betöltéshez',
    icon: KMLIcon,
    color: cyan600,
  },

  multiple: {
    message: 'Egyszerre csak egy fájlt tölts fel',
    icon: MultipleIcon,
    color: grey600,
  },

  unknown: {
    message: 'Csak .KML/.KMZ fájlok feltöltése támogatott',
    icon: UnknownIcon,
    color: grey600,
  },

  processing: {
    message: 'A fájl feldolgozása folyamatban...',
    icon: ProcessingIcon,
    color: cyan600,
  },

  error: {
    message: 'Hiba történt a fájl feldolgozásakor',
    icon: ErrorIcon,
    color: red600,
  },
};

export default DND_STATES;



// WEBPACK FOOTER //
// ./components/DNDOverlay/states.js